import React from "react";

function Location() {
  return (
    <section id="location" className="organization-section">
      <h2>Localização</h2>
      <p>
        A MIUP 2024 decorrerá na Escola Superior de Tecnologia e Gestão de
        Águeda da Universidade de Aveiro.
      </p>
      <div className="organization-column">
        <div className="map-container">
          <iframe
            title="Localização"
            src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d1558.1473106386702!2d-8.44467526595551!3d40.57384142528499!3m2!1i1024!2i768!4f13.1!5e1!3m2!1spt-PT!2spt!4v1727019864431!5m2!1spt-PT!2spt"
            width="800"
            height="600"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
} 

export default Location;